import { render } from "./EditTableModalComponent.vue?vue&type=template&id=6c8822e9&scoped=true"
import script from "./EditTableModalComponent.vue?vue&type=script&lang=js"
export * from "./EditTableModalComponent.vue?vue&type=script&lang=js"

import "./EditTableModalComponent.vue?vue&type=style&index=0&id=6c8822e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8822e9"]])

export default __exports__